import React from 'react';
import { useAtomValue } from 'jotai';
import { metricPanelShareAtom } from '@components/metrics-panel-hz/atoms';
import {
  globalFilterRulesExpandedAtom,
  globalFilterAppendedAtomStatusAtom,
} from '@components/filter/global-atoms';
import { panelsAtom, currentKpiIdAtom } from '@src/atoms/panels';
import { DASHBOARD_TYPE, isAppModule } from '@utils/constants';
import useSaveSet, { SavingStateObjectType } from '@components/saving/useSaveSet';
import { diagnosticsAtom } from '@src/atoms/toggles';
import {
  isTableCompareEnabledAtom,
  dimensionPanelShareAtom,
} from '@src/components/dimension-panel-hz/atoms/index';
import { savingSelector } from '@store/trends/dashboard/selectors';
import { useSelector } from 'react-redux';
import { pageMetaAtom } from '@src/atoms/pageMeta';
import { useWidgetStateForSave } from '@src/components/widget-panel/state/dashboard';

// TODO: evaluate merging of save/share data and apply flows
function LatchSave() {
  const savingState = useSelector(savingSelector);
  const metricPanel = useAtomValue(metricPanelShareAtom);
  const dimensionPanel = useAtomValue(dimensionPanelShareAtom);
  const sections = useAtomValue(panelsAtom);
  const diagnostics = useAtomValue(diagnosticsAtom);
  const isTableCompareEnabled = useAtomValue(isTableCompareEnabledAtom);
  const globalFilterRulesExpanded = useAtomValue(globalFilterRulesExpandedAtom);
  const globalFilterAppendedAtomStatus = useAtomValue(globalFilterAppendedAtomStatusAtom);
  const currentKpiId = useAtomValue(currentKpiIdAtom);

  const { pageKey } = useAtomValue(pageMetaAtom);

  const widgetState = useWidgetStateForSave();

  const { state, ...meta } = savingState;

  const formattedState = {
    ...meta,
    state: {
      ...state,
      metricPanel,
      isTableCompareEnabled,
      dimensionPanel,
      toggles: {
        sections,
        diagnostics,
      },
      globalFilter: {
        rulesExpanded: globalFilterRulesExpanded,
        appendedAtomStatus: globalFilterAppendedAtomStatus,
      },
      widgetState,
      // currentKpiId,
      currentKpiIdSelected: currentKpiId,
    },
  };

  // save can be triggered form close button as well as the kebab
  // TODO: it should be set from a generic section/root instead
  const saveData: SavingStateObjectType = {
    meta: { dashboardTypeId: isAppModule ? DASHBOARD_TYPE.APP_EXPERIENCE : DASHBOARD_TYPE.TRENDS },
    config: formattedState,
  };

  useSaveSet({ pageKey, saveData });

  return <></>;
}

export default LatchSave;
